export { default, StyledImage } from './Image';
export type { ImageProps } from './Image';
